/**
 * Browser logging that stays quiet in production builds.
 * Keeps diagnostics available in development without shipping internals to users.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};

export default logger;
